export default function Footer() {

    const date = new Date().getFullYear();

    return (
        <div id="footer_div">
            <div id="div_para">
                <p id="footer_para">Copyright © {date} Easy Data Structures. All Rights Reserved.</p>
                    
            </div>
        </div>
    )
}